import React from 'react';
import queryString from 'query-string';
import { Form, Progress } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { WithLocalize } from '../../containers/I18nProvider';
import { WithCaptcha } from '../../containers/captcha';
import { checkDeviceIOS, checkUserAgentCustom } from '../../utils'

import logo from './img/sup.png'
import { VERSION_TBX_APP } from './constants';

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = 'sup';
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      showPassword: false,
      error: {
        open: false,
        message: ''
      },
      username: '',
      password: ''
    };
  }

  componentDidMount() {

    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message
      }
    });
  }

  togglePasswordVisibility() {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  }

  async onSubmit(ev) {
    ev.preventDefault();

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: ''
      }
    });



    this.props.api.userPassLogin(
      {
        username: this.usernameInput.value,
        password: this.passwordInput.value,
      }, this.parameters

    )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location = this.parameters.redirect_uri + '?' + queryString.stringify(response);
      })
      .catch(error => {
        const translate = this.props.translate(error.errorCode);

        let message = this.props.translate('LoginErrorBody')
          || 'Revisá tu usuario y contraseña e intentá nuevamente.';

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }

        this.setState({ onLogin: false, error: { open: true, message: message } });
      });
  }

  render() {
    const { translate } = this.props;

    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <div ref={this.ref}>
          <Form onSubmit={event => this.onSubmit(event)} className='form-signin-sup'>
            <div className="logo-sup"><img src={logo} alt='MIO LOGO' /></div>
            <input
              className="form-control-mio"
              disabled={this.state.onLogin}
              placeholder={translate('PlaceholderUserName')}
              ref={(ref) => {
                this.usernameInput = ref;
              }
              }
              required={true}
              tabIndex={1}
              type="text"
              autoCorrect="off"
              autoCapitalize="none"
              name="username"
            />
            <div className="password-field-sup">
              <input
                className="form-control-mio password-input-sup"
                required={true}
                disabled={this.state.onLogin}
                placeholder={translate('PlaceholderPassword')}
                ref={(ref) => {
                  this.passwordInput = ref;
                }
                }
                tabIndex={1}
                type={this.state.showPassword ? 'text' : 'password'}
                autoCorrect="off"
                autoCapitalize="none"
                name="password"
              />
              <button
                type="button"
                className="password-toggle-sup"
                onClick={() => this.togglePasswordVisibility()}
                aria-label={this.state.showPassword ? 'Ocultar password' : 'Mostrar password'}
                disabled={this.state.onLogin}
              >
                <i className={this.state.showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'} aria-hidden="true"></i>
              </button>
            </div>
            <div className="buttons">
              {!this.state.onLogin ?
                <button
                  block={!this.parameters.failureRedirect}
                  tabIndex={1}
                  className="btn-mio"
                  type="submit"
                  name="submit"
                  disabled={!this.props.turnstileSuccess}
                >
                  {translate('ButtonEnter')}
                </button> :
                <Progress animated color="danger" value={100} />}
            </div>
            {
              checkDeviceIOS() && checkUserAgentCustom(VERSION_TBX_APP) ? <></> :
                <>
                  <p className="message-cont-mio">
                    <a className="message-mio" href="https://mio.tv/#sectionPlans">Registrate aquí</a>
                  </p>
                  <p className="message-cont-mio">
                    <a className="message-mio" href="https://mio.tv/recuperar">Recuperá tu contraseña</a>
                  </p>
                </>
            }
            {this.state.error.open && (
              <div className="error-box-mio" role="alert">
                <div className="error-box-mio__header">
                  <span className="error-box-mio__icon" aria-hidden="true">!</span>
                  <p className="error-box-mio__title">
                    {translate('LoginErrorTitle') || 'No pudimos iniciar sesión.'}
                  </p>
                </div>
                <p className="error-box-mio__body">
                  {this.state.error.message}
                </p>
                <a
                  className="error-box-mio__help"
                  href="https://app.mio.tv/ar/ayuda-web"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {translate('HelpCenterLink') || 'Ir al Centro de Ayuda'}
                  <span aria-hidden="true"> →</span>
                </a>
              </div>
            )}
            <this.props.TurnstileComponent setTurnstileSuccess={this.props.setTurnstileSuccess} />
          </Form>
        </div>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
